/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Kind_FeedbackInputs */

const en_us2_offline_kind_feedback = /** @type {(inputs: Offline_Kind_FeedbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workout feedback`)
};

const pt_br2_offline_kind_feedback = /** @type {(inputs: Offline_Kind_FeedbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avaliação do treino`)
};

const es_419_offline_kind_feedback = /** @type {(inputs: Offline_Kind_FeedbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evaluación del entrenamiento`)
};

const pt_pt2_offline_kind_feedback = /** @type {(inputs: Offline_Kind_FeedbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avaliação do treino`)
};

const fr_fr2_offline_kind_feedback = /** @type {(inputs: Offline_Kind_FeedbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avis sur la séance`)
};

const de_de2_offline_kind_feedback = /** @type {(inputs: Offline_Kind_FeedbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trainingsfeedback`)
};

const it_it2_offline_kind_feedback = /** @type {(inputs: Offline_Kind_FeedbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valutazione dell'allenamento`)
};

/**
* | output |
* | --- |
* | "Workout feedback" |
*
* @param {Offline_Kind_FeedbackInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const offline_kind_feedback = /** @type {((inputs?: Offline_Kind_FeedbackInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Kind_FeedbackInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_offline_kind_feedback(inputs)
	if (locale === "es-419") return es_419_offline_kind_feedback(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_kind_feedback(inputs)
	if (locale === "fr-FR") return fr_fr2_offline_kind_feedback(inputs)
	if (locale === "de-DE") return de_de2_offline_kind_feedback(inputs)
	if (locale === "it-IT") return it_it2_offline_kind_feedback(inputs)
	return en_us2_offline_kind_feedback(inputs)
});
export { offline_kind_feedback as "offline.kind_feedback" }